module.exports = __webpack_public_path__ + "img/right-from-bracket.de9dca84.svg";